<template>
  <div class="tabs">
    <div v-for="(item, index) in tabsName" :key="item" :class="index == activeIndex ? 'activeTab' : 'normalTab'" :style="`width:${98/tabsName.length}%`" @click="active(index)">{{item}}</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      tabsName: ['待使用', '已使用', '已取消', '已过期'],
      activeIndex: 0
    };
  },

  props: ['tabs'],

  methods: {
    active(index) {
      this.activeIndex = index
      this.$parent.activeTab(index)
    }
  },

  created() {
    this.tabsName = this.tabs && this.tabs.length ? this.tabs : this.tabsName
    let index = sessionStorage.getItem('activeTabIndex')
    if (index) {
      this.active(index)
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.tabs{
  background-color: #FFFDFA;
  text-align: center;
  line-height: 1.2rem;
  font-size: 0.4rem;
  color: #333;
  padding: 0 3%;
  padding-top: 0.3rem;
  border-bottom: 0.013rem solid #E4CEAE;
  div{
    display: inline-block;
    font-weight: 500;
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;
    cursor: pointer;
  }
  .activeTab{
    position: relative;
    &:after{
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -0.55rem;
      width: 1.1rem;
      height: 0.052rem;
      display: inline-block;
      content: '';
    }
    // color: #fff;
  }
}
</style>
